import * as React from 'react';
import styled from "styled-components";
import TwoColumnTable, {TwoColumnTableItem, TwoColumnTableProps} from "components/TwoColumnTable";
import DoughnutChart, {DoughnutChartItem} from "components/DoughnutChart";
import {getNumberFromPercentValue} from "../../helpers";
import Filter from "../Filter";

export interface StatisticLocationProps {
  countryData: TwoColumnTableProps;
  cityData: TwoColumnTableProps;
  colors: string[];
}

const Container = styled.div`
  display: grid;
  gap: 20px;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 
    minmax(375px, 490px) 
    minmax(375px, 380px);
  gap: 18px;
`;

const ChartBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: 
    1px
    solid
    ${({theme}) => theme.variables.borderColor};
`;

export default function StatisticLocation(props: StatisticLocationProps) {
  const [period, setPeriod] = React.useState<string | number>('today')

  /**
   * the function return data array for doughnut chart
   */
  function getDoughnutChartData(dataType: 'country' | 'city'): DoughnutChartItem[] {
    /**
     * the function return data object for doughnut chart
     */
    function getDataFromItem(item: TwoColumnTableItem): DoughnutChartItem {
      return {
        label: item.label,
        value: getNumberFromPercentValue(item.value)
      }
    }

    if (dataType === 'country') {
      return props
        .countryData
        .items
        .map(getDataFromItem)
    }

    return props
      .cityData
      .items
      .map(getDataFromItem)
  }

  return (
    <Container>
      <Filter
        defaultValue={period}
        onChange={(value) => setPeriod(value)}
        items={[
          {
            label: 'Сегодня',
            value: 'today',
          },
          {
            label: 'Неделя',
            value: 'week',
          },
          {
            label: 'Месяц',
            value: 'month',
          },
          {
            label: 'Квартал',
            value: 'quarter',
          },
          {
            label: 'Год',
            value: 'year',
          },
          {
            label: 'Всё время',
            value: 'allTime',
          },
        ]}
      />
      <Row>
        <TwoColumnTable {...props.countryData} />
        <ChartBox>
          <DoughnutChart
            data={getDoughnutChartData('country')}
            colors={props.colors}
            pie
          />
        </ChartBox>
      </Row>
      <Row>
        <TwoColumnTable {...props.cityData} />
        <ChartBox>
          <DoughnutChart
            data={getDoughnutChartData('city')}
            colors={props.colors}
            pie
          />
        </ChartBox>
      </Row>
    </Container>
  )
}